import { Menu } from '@astro-ui/components'
import { AstroUIThemeType } from '@astro-ui/theme'
import styled, { css } from 'styled-components'

export const Fieldset = styled.div<{ disabled?: boolean; isError?: boolean }>`
  position: relative;
  border: 1px solid #b3b3b3;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 10px 16px;
  padding-right: 42px !important;
  width: 100%;
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: #eeeeee;
      cursor: default;
      p {
        color: #cccccc;
      }
    `}

  ${({ isError, theme }) =>
    isError &&
    css`
      border-color: ${theme.palette.error.main};
    `}
`

export const IconExpand = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
`

export const DatePickerMenu = styled(Menu)`
  .MuiMenu-list {
    padding: 0px;
    overflow: auto;
  }

  .MuiPopover-paper {
    max-height: fit-content !important;
  }

  .rdrCalendarWrapper {
    width: fit-content;
  }

  .rdrMonthAndYearPickers select {
    font-family: ${({ theme }) => theme.fontFamily.nunitoSans};
    color: black;
  }

  .rdrWeekDay {
    font-family: ${({ theme }) => theme.fontFamily.nunitoSans};
    color: black;
  }

  .rdrDayNumber span {
    font-family: ${({ theme }) => theme.fontFamily.nunitoSans};
  }
`

export const LeftMenu = styled.div`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  position: relative;
  padding: 8px 24px;

  span {
    font-weight: 600;
    :hover {
      color: ${({ theme }) => theme.colors.blue6};
    }
  }

  ${({ selected, disabled }: { selected?: boolean; disabled?: boolean }) => {
    if (selected) {
      return css`
        span {
          color: ${({ theme }) => theme.colors.blue6};
        }
        ::before {
          content: ' ';
          position: absolute;
          top: 0;
          left: 0;
          width: 4px;
          height: 100%;
          background-color: ${({ theme }) => theme.colors.blue6};
        }
      `
    }

    if (disabled) {
      return css`
        span,
        span:hover {
          color: ${({ theme: { colors } }) => colors.grey2};
        }
      `
    }

    return ''
  }}
`

export const RightMenu = styled.div`
  position: relative;
  padding: 8px 24px;
  text-align: right;

  ${({ selected }: { selected?: boolean }) =>
    selected &&
    css`
      span {
        color: ${({ theme }) => theme.colors.blue6};
      }
    `}
`

export const Action = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 8px 16px;
  border-top: 1px solid #eeeeee;
`

export const DateWrapper = styled.div`
  border-left: 1px solid #eeeeee;
  padding: 0px 12px;
`

export const MonthCard = styled.div<{ selected: boolean; disabled?: boolean }>`
  width: 30.3%;
  height: 40px;
  background-color: ${({ selected, theme }: { selected: boolean; theme: AstroUIThemeType }) =>
    selected ? theme.colors.blue6 : theme.colors.grey1};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    `}
`
